import { ToggleButton, ToggleButtonGroup, Typography, styled, alpha } from "@mui/material";
import { IEntity } from "../../models/Types";
import { ListApiRef } from "./ApiRef";

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    backgroundColor: theme.palette.info.main,
    padding: theme.spacing(.5),
    gap: theme.spacing(.5),
    "& .MuiButtonBase-root.MuiToggleButton-root": {
        border: 'none',
        textTransform: 'none',
        borderRadius: theme.spacing(.5),
        color: theme.palette.primary.main,
        "&.Mui-disabled": {
            backgroundColor: '#fff'
        },
        "&:hover": {
            backgroundColor: alpha('#fff', .4)
        }
    }
}));

export interface ViewMode<T extends IEntity> {
    mode: string,
    hideAnyFilter?: boolean;
    hideAddBtn?: boolean;
    text?: React.ReactNode,
    view?: (apiRef:(api?: ListApiRef<T>) => void) => React.ReactNode
}

export function buildViewModes<T extends IEntity>(modes?: ViewMode<T>[], viewMode?: string, setViewMode?: ((viewMode: string) => void)) {
    if (modes && modes.length > 1) {
        return <StyledToggleButtonGroup
            className="viewmodes-selector"
            exclusive
            value={viewMode}
            onChange={(e, v) => setViewMode && setViewMode(v)} sx={{ marginLeft: 1 }}>
            {modes.map(x => <ToggleButton value={x.mode} disabled={viewMode == x.mode}><Typography variant="body2">{x.text || x.mode}</Typography></ToggleButton>)}
        </StyledToggleButtonGroup>;
    }
}